module.exports = __webpack_public_path__ + "media/images/pin_icon-b84096274127106a100bd55b6d13cde6.png";